var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406 306",
    style: {
      enableBackground: "new 0 0 406 306"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C5D8E8;}\n\t.st1{fill:#4582B4;}\n\t.st2{fill:#6E9EC5;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#C3D7E7;}\n\t.st5{fill:#FBF7D1;}\n\t.st6{fill:#F5E984;}\n\t.st7{fill:#A9C6DD;}\n\t.st8{fill:#F56132;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_03_web_development_outline"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.9,226.5c0.3-0.9,0.4-1.9,0.4-2.9c0-8.3-10.2-15.1-22.7-15.1s-22.7,6.8-22.7,15.1c0,1,0.1,2,0.4,2.9H302.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.9,227.5h-44.6c-0.5,0-0.9-0.3-1-0.7c-0.3-1-0.5-2.1-0.5-3.2c0-8.9,10.6-16.1,23.7-16.1 s23.7,7.2,23.7,16.1c0,1.1-0.2,2.2-0.5,3.2C303.7,227.2,303.3,227.5,302.9,227.5z M259.1,225.5h43c0.1-0.6,0.2-1.3,0.2-1.9 c0-7.8-9.7-14.1-21.7-14.1s-21.7,6.3-21.7,14.1C258.9,224.2,259,224.9,259.1,225.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.6,218.5c-0.6,0-1-0.5-1-1v-9c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v9C281.6,218.1,281.2,218.5,280.6,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89,226.5h228c3.2,0,5.9,2.6,5.9,5.9v1c0,3.2-2.6,5.9-5.9,5.9H89c-3.2,0-5.9-2.6-5.9-5.9v-1 C83.1,229.1,85.8,226.5,89,226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317,240.2H89c-3.8,0-6.9-3.1-6.9-6.9v-1c0-3.8,3.1-6.9,6.9-6.9h228c3.8,0,6.9,3.1,6.9,6.9v1 C323.9,237.1,320.8,240.2,317,240.2z M89,227.5c-2.7,0-4.8,2.2-4.8,4.8v1c0,2.7,2.2,4.8,4.8,4.8h228c2.7,0,4.8-2.2,4.8-4.8v-1 c0-2.7-2.2-4.8-4.8-4.8H89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.6,75h144.7c5.6,0,10.1,4.5,10.1,10.1v104.5c0,5.6-4.5,10.1-10.1,10.1H130.6c-5.6,0-10.1-4.5-10.1-10.1 V85.1C120.5,79.5,125,75,130.6,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.4,200.7H130.6c-6.2,0-11.2-5-11.2-11.2l0,0V85.1c0-6.2,5-11.2,11.2-11.2h144.7c6.2,0,11.2,5,11.2,11.2 v104.4C286.5,195.7,281.5,200.7,275.4,200.7L275.4,200.7z M130.6,76c-5,0-9.1,4.1-9.1,9.1v104.4c0,5,4.1,9.1,9.1,9.1h144.7 c5,0,9.1-4.1,9.1-9.1V85.1c0-5-4.1-9.1-9.1-9.1H130.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "232.3,226.5 173.7,226.5 179.9,199.7 226.1,199.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.3,227.5h-58.5c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.3-0.6-0.2-0.9l6.1-26.8c0.1-0.5,0.5-0.8,1-0.8h46.3 c0.5,0,0.9,0.3,1,0.8l6.1,26.8c0.1,0.3,0,0.6-0.2,0.9C232.9,227.4,232.6,227.5,232.3,227.5z M175,225.5h56l-5.6-24.8h-44.7 L175,225.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.7,
    y: 85.4,
    className: "st3",
    width: 142.5,
    height: 92.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.3,178.9H131.7c-0.6,0-1-0.5-1-1V85.4c0-0.6,0.5-1,1-1h142.5c0.6,0,1,0.5,1,1V178 C275.3,178.5,274.8,178.9,274.3,178.9z M132.8,176.9h140.5V86.4H132.8V176.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.7,
    y: 85.4,
    className: "st3",
    width: 42,
    height: 92.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.7,178.9h-42c-0.6,0-1-0.5-1-1V85.4c0-0.6,0.5-1,1-1h42c0.6,0,1,0.5,1,1V178 C174.8,178.5,174.3,178.9,173.7,178.9z M132.8,176.9h40V86.4h-40V176.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.7,
    y: 85.4,
    className: "st1",
    width: 100.5,
    height: 92.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.3,178.9H173.8c-0.6,0-1-0.5-1-1V85.4c0-0.6,0.5-1,1-1h100.5c0.6,0,1,0.5,1,1V178 C275.3,178.5,274.8,178.9,274.3,178.9z M174.8,176.9h98.5V86.4h-98.5L174.8,176.9L174.8,176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.1,98.1H144c-0.6,0-1-0.5-1-1s0.5-1,1-1h17.1c0.6,0,1,0.5,1,1S161.7,98.1,161.1,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164,108.1h-14.4c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1H164c0.6,0,1,0.5,1,1S164.6,108.1,164,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166,118.1h-12c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h12c0.6,0,1,0.5,1,1S166.5,118.1,166,118.1L166,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.1,128H147c-0.6,0-1-0.5-1-1s0.5-1,1-1h15.1c0.6,0,1,0.5,1,1S162.6,128,162.1,128L162.1,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158,138h-14c-0.6,0-1-0.5-1-1s0.5-1,1-1h14c0.6,0,1,0.5,1,1S158.6,138,158,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.1,148h-12.3c-0.6,0-1-0.5-1-1s0.5-1,1-1h12.3c0.6,0,1,0.5,1,1S161.7,148,161.1,148z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.8,158H144c-0.6,0-1-0.5-1-1s0.5-1,1-1h12.8c0.6,0,1,0.5,1,1S157.4,158,156.8,158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.1,168h-12.3c-0.6,0-1-0.5-1-1s0.5-1,1-1h12.3c0.6,0,1,0.5,1,1S161.7,168,161.1,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204,98.1h-17c-0.6,0-1-0.5-1-1s0.5-1,1-1h17c0.6,0,1,0.5,1,1S204.6,98.1,204,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.5,108.1h-35c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h35c0.6,0,1,0.5,1,1S228.1,108.1,227.5,108.1L227.5,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M218.8,118.1h-26.3c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h26.3c0.6,0,1,0.5,1,1S219.4,118.1,218.8,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204.9,128h-15.1c-0.6,0-1-0.5-1-1s0.5-1,1-1h15.1c0.6,0,1,0.5,1,1S205.5,128,204.9,128L204.9,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211,138h-17.1c-0.6,0-1-0.5-1-1s0.5-1,1-1H211c0.6,0,1,0.5,1,1S211.5,138,211,138L211,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.6,148h-26.3c-0.6,0-1-0.5-1-1s0.5-1,1-1h26.3c0.6,0,1,0.5,1,1S220.2,148,219.6,148z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M199.7,158h-12.8c-0.6,0-1-0.5-1-1s0.5-1,1-1h12.8c0.6,0,1,0.5,1,1S200.3,158,199.7,158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M219.6,168h-28c-0.6,0-1-0.5-1-1s0.5-1,1-1h28c0.6,0,1,0.5,1,1S220.2,168,219.6,168L219.6,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M246.5,168h-18.4c-0.6,0-1-0.5-1-1s0.5-1,1-1h18.4c0.6,0,1,0.5,1,1S247,168,246.5,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.6,118.1h-13c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13c0.6,0,1,0.5,1,1S241.1,118.1,240.6,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259,108.1h-25c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h25c0.6,0,1,0.5,1,1C260.1,107.6,259.6,108.1,259,108.1 L259,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M254.9,118.1h-7.3c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h7.3c0.6,0,1,0.5,1,1S255.4,118.1,254.9,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223.3,138H216c-0.6,0-1-0.5-1-1s0.5-1,1-1h7.3c0.6,0,1,0.5,1,1S223.9,138,223.3,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M259,138h-29.7c-0.6,0-1-0.5-1-1s0.5-1,1-1H259c0.6,0,1,0.5,1,1S259.6,138,259,138L259,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234,148h-6.5c-0.6,0-1-0.5-1-1s0.5-1,1-1h6.5c0.6,0,1,0.5,1,1S234.6,148,234,148z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M259,168h-4.2c-0.6,0-1-0.5-1-1s0.5-1,1-1h4.2c0.6,0,1,0.5,1,1S259.6,168,259,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.4,66.8h62.2c2.4,0,4.4,2,4.4,4.4v47.3c0,2.4-2,4.4-4.4,4.4h-62.2c-2.4,0-4.4-2-4.4-4.4V71.2 C247,68.8,249,66.8,251.4,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.6,124h-62.2c-3,0-5.4-2.4-5.4-5.4V71.2c0-3,2.4-5.4,5.4-5.4h62.2c3,0,5.4,2.4,5.4,5.4v47.3 C319.1,121.5,316.6,124,313.6,124z M251.4,67.8c-1.9,0-3.4,1.5-3.4,3.4v47.3c0,1.9,1.5,3.4,3.4,3.4h62.2c1.9,0,3.4-1.5,3.4-3.4 V71.2c0-1.9-1.5-3.4-3.4-3.4C313.6,67.8,251.4,67.8,251.4,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318,80.7h-71c-0.6,0-1-0.5-1-1s0.5-1,1-1h71c0.6,0,1,0.5,1,1S318.6,80.7,318,80.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 253.8,
    cy: 73.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 260.2,
    cy: 73.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 266.6,
    cy: 73.1,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.8,109.5c-0.2,0-0.5-0.1-0.6-0.2l-9.6-7.9c-0.4-0.4-0.5-1-0.1-1.4l0.1-0.1l9.6-7.9 c0.5-0.3,1.1-0.2,1.4,0.2c0.3,0.4,0.2,1-0.1,1.3l-8.6,7.1l8.6,7.1c0.4,0.4,0.5,1,0.1,1.4l0,0C274.4,109.4,274.1,109.5,273.8,109.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.3,109.5c-0.3,0-0.6-0.1-0.8-0.4c-0.4-0.4-0.3-1.1,0.1-1.4l0,0l8.6-7.1l-8.6-7.1c-0.4-0.4-0.5-1-0.1-1.4 s1-0.5,1.4-0.1l9.5,7.9c0.4,0.4,0.5,1,0.1,1.4l-0.1,0.1l-9.5,8C291.7,109.5,291.5,109.6,291.3,109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.4,114.3c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.7-0.8-0.5-1.3l0,0l11.2-25.3c0.2-0.5,0.8-0.7,1.3-0.5l0,0 c0.5,0.2,0.7,0.8,0.5,1.3l0,0l-11.2,25.3C278.2,114,277.8,114.3,277.4,114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.2,183.7h47.3c2.1,0,3.9,1.7,3.9,3.9v21.6c0,2.1-1.7,3.9-3.9,3.9h-47.3c-2.1,0-3.9-1.7-3.9-3.9v-21.6 C105.3,185.4,107.1,183.7,109.2,183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,214.1h-47.3c-2.7,0-4.9-2.2-4.9-4.9v-21.7c0-2.7,2.2-4.9,4.9-4.9h47.3c2.7,0,4.9,2.2,4.9,4.9l0,0v21.7 C161.4,211.9,159.2,214.1,156.5,214.1L156.5,214.1z M109.2,184.7c-1.6,0-2.9,1.3-2.9,2.9l0,0v21.7c0,1.6,1.3,2.9,2.9,2.9l0,0h47.3 c1.6,0,2.9-1.3,2.9-2.9l0,0v-21.7c0-1.6-1.3-2.9-2.9-2.9l0,0H109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.6,193.9h1.5v3.4h4.1v-3.4h1.5v8.6h-1.5v-3.8h-4.1v3.8h-1.5V193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.4,195.3h-2.6v-1.4h6.8v1.4H129v7.2h-1.5L127.4,195.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.6,193.9h2.4l2.3,6l2.3-6h2.3v8.6h-1.5v-7.2l0,0l-2.6,7.2h-1.1l-2.6-7.2l0,0v7.2h-1.5L132.6,193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.9,193.9h1.5v7.2h3.7v1.4h-5.2V193.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card-1.35e8a4102b38b564b3ba7f518e83da6b.svg";
export { ForwardRef as ReactComponent };